import * as React from "react";
type Props = {
  className?: string,
};
function SvgSmokedfish({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Smoked fish"
      className={className}
    >
      <path
        d="M1.42864 20.3447C3.52516 21.8654 5.72342 23.6116 7.81857 25.133M1.42864 20.3447C1.42864 20.3447 1.43203 24.5599 1.42859 25.291C2.41563 26.0924 5.38432 28.4986 7.64317 30C9.07249 29.6331 36.4476 19.3461 37.837 18.4598C38.0606 18.3178 38.6191 17.9612 38.5682 17.584C38.542 17.3929 38.366 17.2529 38.0977 17.0978C37.1905 16.5729 36.3513 16.4978 36.3513 16.4978C35.6903 16.4384 34.7583 16.2157 32.8942 15.7695C31.3521 15.4005 30.2846 14.9977 29.9861 14.8832C28.8842 14.4598 28.6324 14.2536 27.9831 13.9977M1.42864 20.3447C1.96171 19.853 2.6942 19.3516 3.76998 18.4764C4.97162 17.5005 5.32448 17.3005 6.13062 16.6226C7.9355 15.1053 7.84814 14.6881 9.20386 13.5198C10.9922 11.977 12.7847 11.2894 13.7002 10.9473C14.7815 10.5425 16.2108 10.0211 18.1216 10.0011C19.813 9.98249 21.1041 10.1949 22.5066 10.8335C25.3116 12.1094 25.7298 13.1218 27.9831 13.9977M7.81857 25.133C9.00463 24.4976 10.1217 23.7404 11.1518 22.8737C11.8421 22.2947 12.489 21.6656 13.0874 20.9916C13.9389 20.0212 14.1652 19.5385 14.8001 18.7136C14.9693 18.493 16.0843 17.0605 17.6429 15.8964C18.3995 15.3322 20.4953 13.8081 23.5885 13.5225C24.4834 13.4398 26.1748 13.2832 27.9831 13.9977M7.81857 25.133L7.87634 30M7.61909 16.8964L11.7461 19.655M10.3704 14.1377L14.4974 16.8964M13.1218 12.0687L16.5609 14.1377M17.2488 11.3791L19.3123 12.0687"
        stroke="currentColor"
        strokeWidth={0.962968}
      />
    </svg>
  );
}
export default SvgSmokedfish;
